module.exports = __webpack_public_path__ + "static/media/granica.297597ef.svg";